'use client';
import { getUserOrganization } from '#pplx/frontend/apps/ask/queries/enterprise-queries/getUserOrganization.js';
import { getUserOrgDataKey } from '#pplx/frontend/apps/ask/queries/query-keys/enterpriseKeys.js';
import { useIsEnterpriseUser } from '#pplx/frontend/auth/useIsEnterpriseUser.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { keepPreviousData } from '@tanstack/react-query';
import { useMemo } from 'react';
export function useUserOrgData({ shouldRefetchOnMount = true, shouldRefetchOnWindowFocus, forceFetch = false, enabled = true, reason, }) {
    const isEnterpriseUser = useIsEnterpriseUser();
    const { data, refetch, isSuccess, isFetching } = useQuery({
        enabled: enabled && (forceFetch || isEnterpriseUser),
        queryKey: getUserOrgDataKey(),
        queryFn: () => getUserOrganization({ reason }),
        // Do not turn a failed policy refresh into a successful cached response.
        meta: { skipPersistence: true },
        placeholderData: keepPreviousData,
        // important. removed this query from server prefetching to speed up initial page load
        // so now we need to fetch it on mount.
        refetchOnMount: shouldRefetchOnMount,
        refetchOnWindowFocus: shouldRefetchOnWindowFocus,
    });
    // The query only fetches when the session is enterprise (or forceFetch); a disabled
    // query still surfaces any existing cache row, so mirror the fetch gate on exposure.
    const exposedData = forceFetch || isEnterpriseUser ? data : undefined;
    return useMemo(() => ({
        orgUser: exposedData?.org_user,
        isAdmin: exposedData?.org_user?.role === 'ADMIN',
        organization: exposedData?.organization,
        isEnterprise: isEnterpriseUser,
        refetch,
        isLoading: !exposedData && isFetching,
        isFetching,
        isSuccess,
    }), [exposedData, isEnterpriseUser, isFetching, isSuccess, refetch]);
}
//# sourceMappingURL=useUserOrgData.js.map